import Layout from "../include/layout";
import { Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from 'dayjs'
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'datatables.net-bs5'
import Filarial from "../include/filarial";
import ProgrammesevaluationsService from "./ProgrammesevaluationsService";
import TypesevaluationsService from "../typesevaluations/TypesevaluationsService";

export default function ProgrammesevaluationsIndex() {
    const activeLink = "PROGRAMMES EVALUATIONS"

    const token = useSelector(state => state.auth.token)
    const [programmesevaluations, setProgrammesevaluations] = useState([])

    const navigate = useNavigate()
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)


    //get liste programmesevaluations
    const fetchProgrammesevaluations = async () => {
        await ProgrammesevaluationsService.index(token).then((res) => {
            //console.log(res.data.data)
            setProgrammesevaluations(res.data.data.programmesevaluations)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }



    //redirection sur la page edit sans afficher les id dans l'url
    const goToEdit = (param) => {
        navigate(myroutes.programmesevaluations_edit, { state: { id: param } })
    }

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                ProgrammesevaluationsService.delete(param, token).then((response) => {
                    //console.log(response.data)
                    if (response.data.status !== 200) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchProgrammesevaluations()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                    console.log(e)
                })
            }
        })
    }

    // formater les date de début et fin
    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "numeric", day: "numeric" };
        return new Date(dateString).toLocaleDateString(undefined, options);
      };


    useEffect(() => {
        fetchProgrammesevaluations();
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
    }, [dispatch])


    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">

                <Filarial activeLink={activeLink} />


                {/* Responsive Datatable */}
                <div className="card shadow-lg mb-4 mt-3">
                    <h5 className="card-header">Liste des programmes d'évaluations &nbsp;&nbsp;
                        <Link to={myroutes.programmesevaluations_create}
                            className="btn btn-warning btn-sm"
                            title="Ajouter"
                        ><FontAwesomeIcon icon="fa-solid fa-circle-plus" /></Link>
                    </h5>
                    <div className="card-datatable table-responsive px-4 pb-3">
                        <table className="dt-responsive table border-top data-table table-hover ">
                            <thead className="bg-primary">
                                <tr style={{ color: "white" }}>
                                    <th className="cell text-white">#</th>
                                    <th className="cell text-white">Classe </th>
                                    <th className="cell text-white">Matière</th>
                                    <th className="cell text-white">Type evaluation</th>
                                    <th className="cell text-white">Date debut</th>
                                    <th className="cell text-white">Date fin</th>
                                    <th className="cell text-white">Description</th>
                                    <th className="cell text-white">Date modifcation</th>
                                    <th className="cell text-white">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {programmesevaluations.length > 0 && programmesevaluations.map((item, index) => (
                                    <tr key={index}>
                                        <td className="cell">{index + 1}</td>
                                        <td className="cell">{item.classesoptions?.libelleClasseOption}
                                        </td>
                                        <td className="cell">{item.matieres?.libelleMatiere}
                                        </td>
                                        <td className="cell">{item.typesevaluations?.libelleTypeEvaluation}</td>
                                        <td className="cell">{formatDate(item.dateDebutProgrammeEvaluation)}</td>
                                        <td className="cell">{formatDate(item.dateFinProgrammeEvaluation)}</td>
                                        <td className="cell">{item.descriptionProgrammeEvaluation}</td>
                                        <td className="cell">
                                            <span>{dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}</span>
                                        </td>
                                        <td className="cell">
                                            <div className="d-flex">
                                                <Button className="btn btn-sm" variant="primary" onClick={() => goToEdit(item.id)}
                                                    title="Modifier">
                                                    <i className="fas fa-edit"></i></Button> &nbsp;&nbsp;

                                                <Button className="btn btn-sm" variant="danger" onClick={() => onDelete(item.id)}
                                                    title="Supprimer">
                                                    <i className="fas fa-trash"></i></Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/*/ Responsive Datatable */}
            </div>


        </Layout>
    )
}